/* This file was automatically generated on 1666691919.933 */

/* eslint-disable global-require */

module.exports = {
  arithmetic: require('./arithmetic'),
  assignment: require('./assignment'),
  bit: require('./bit'),
  comparison: require('./comparison'),
  exponentiation: require('./exponentiation'),
  logical: require('./logical'),
  shift: require('./shift')
};
